import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import Error from "../../../components/Error";
import { useAuth } from "../hooks/useAuth";
import Loading from "../../../components/Loading";
import { useLocation } from "react-router-dom";
import queryString from "querystring";
import { mutateErrors } from "../../../utils";
import { useHistory } from "react-router";
import useUserQueries from "../../user/hooks/useUserQueries";

export default function ActivatePage() {
  const location = useLocation();
  const { replace } = useHistory();
  const [activating, setActivating] = useState<boolean | string>(true);
  const { user } = useAuth();
  const { fetchActivate } = useUserQueries();

  let queryParams = queryString.parse(location.search.split("?").join(""));
  let code: any = queryParams.code;

  useEffect(() => {
    if (user && user.verified) {
      replace(`/0`);
      return;
    }
    if (code) {
      (async () => {
        try {
          const { data } = await fetchActivate(code);
          if (
            data.user &&
            data.user.accessToken &&
            data.user.accessToken.token
          ) {
            replace(`/0?token=${data.user.accessToken.token}`);
          }
        } catch (e) {
          const { message } = mutateErrors(e);
          setActivating(message);
        }
      })();
    }
  }, [code, user]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!code) {
    return <Error text={"Invalid code."}></Error>;
  }

  if (typeof activating == "string") {
    return <Error text={activating}></Error>;
  }

  return activating === true && <Loading />;
}
